import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "ATR Short ID:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Job Title:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Doctype:", -1);
const _hoisted_15 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_16 = {
    key: 0,
    class: "flex justify-end"
};
import { computed, inject, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import formThirteen from '@/components/approvalWorkflowForms/collectingApplications.vue';
import formTwelve from '@/components/approvalWorkflowForms/firstSecondApproval.vue';
import formFourteen from '@/components/approvalWorkflowForms/generateOffers.vue';
import TaleoForm from '@/components/approvalWorkflowForms/taleoRecruitment.vue';
import ViewOffers from '@/components/approvalWorkflowForms/ViewOffers.vue';
import formEight from '@/components/create-starter/formEight.vue';
import formEleven from '@/components/create-starter/formEleven.vue';
import formFive from '@/components/create-starter/formFive.vue';
import formFour from '@/components/create-starter/formFour.vue';
import formNine from '@/components/create-starter/formNine.vue';
import formOne from '@/components/create-starter/formOne.vue';
import formSeven from '@/components/create-starter/formSeven.vue';
import formSix from '@/components/create-starter/formSix.vue';
import formTen from '@/components/create-starter/formTen.vue';
import formThree from '@/components/create-starter/formThree.vue';
import formTwo from '@/components/create-starter/formTwo.vue';
import httpClient from '@/httpClient';
import formLayout from '@/layouts/formLayout.vue';
import { saveStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'step7SelectionComplete',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formPoint = ref(0);
        const stages = inject('stages', []);
        const navItemConfig = [
            {
                formPoint: 0,
                name: 'selection',
                text: 'View Offers',
                component: ViewOffers,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 1,
                name: 'selection',
                text: 'Generate Offers',
                component: formFourteen,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 2,
                name: 'resourcing',
                text: 'Taleo Recruitment',
                component: TaleoForm,
                icon: 'UserCircleIcon',
            },
            {
                formPoint: 3,
                name: 'collectingApplications',
                text: 'Collecting Applications',
                component: formThirteen,
                icon: 'UserIcon',
            },
            {
                formPoint: 4,
                name: 'formOne',
                text: 'Hiring Manager & Secondary Contact Details',
                component: formOne,
                icon: 'UserIcon',
            },
            {
                formPoint: 5,
                name: 'formTwo',
                text: 'Recruitment Reason',
                component: formTwo,
                icon: 'LogoutIcon',
            },
            {
                formPoint: 6,
                name: 'formThree',
                text: 'Job Details',
                component: formThree,
                icon: 'EmojiHappyIcon',
            },
            {
                formPoint: 7,
                name: 'formFour',
                text: 'Organisation Details',
                component: formFour,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 8,
                name: 'formFive',
                text: 'Hours Of Work',
                component: formFive,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 9,
                name: 'formSix',
                text: 'Contract Details',
                component: formSix,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 10,
                name: 'formSeven',
                text: 'Advertising Requirements',
                component: formSeven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 11,
                name: 'formEight',
                text: 'Pre Employment Checks',
                component: formEight,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 12,
                name: 'formNine',
                text: 'Security',
                component: formNine,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 13,
                name: 'formTen',
                text: 'Specialist Roles',
                component: formTen,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 14,
                name: 'formEleven',
                text: 'Attachments',
                component: formEleven,
                icon: 'DocumentTextIcon',
            },
            {
                formPoint: 15,
                name: 'formEleven',
                text: 'First & Second Line Approval',
                component: formTwelve,
                icon: 'DocumentTextIcon',
            },
        ];
        const formData = ref({
            resourcingOwner: {},
            formOne: {},
            formTwo: {},
            formThree: {},
            formFour: {},
            formFive: {},
            formSix: {},
            formSeven: {},
            formEight: {},
            formNine: {},
            formTen: {},
            formEleven: {},
            formTwelve: {},
            collectingApplications: {},
            selection: {
                offering_to: [],
            },
            resourcing: {},
        });
        const configItems = ref({});
        const profile = computed(() => store.getters.getProfile);
        const currentNavItem = computed(() => navItemConfig.find((item) => item.formPoint === formPoint.value));
        const disableForm = computed(() => currentNavItem.value?.name !== 'selection');
        const handleCloseAtr = async () => {
            store.dispatch('setIsLoading', true);
            const payload = {
                docOwner: formData.value.requestedBy,
                docId: formData.value.docId,
                state: 'starter.notifyCandidateSelected',
            };
            await httpClient.post('/bff/complete-request', payload);
            store.dispatch('setIsLoading', false);
            router.push('/');
        };
        const setCurrentNavItem = (value) => {
            formPoint.value = value;
        };
        const handleSubmitForm = async ({ name, data, }) => {
            try {
                store.dispatch('setIsLoading', true);
                formData.value[name].saved = true;
                const payload = {
                    formData: { ...data },
                    requestedBy: docOwner.value,
                    id: docId.value,
                    stage: formData.value.currentStageName,
                };
                const res = await httpClient.post(`/bff/starter/${name}`, payload);
                formData.value = res.data.body?.Item ?? {};
                saveStorage('formData', JSON.stringify(formData.value));
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'SAVED!',
                    message: 'The form has been saved.',
                });
                router.push('/');
                store.dispatch('setIsLoading', false);
            }
            catch (err) {
                console.log(err);
                formData.value[name].saved = false;
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was an error submitting the form',
                });
                store.dispatch('setIsLoading', false);
            }
        };
        const handleGenerateOffers = async ({ name, data, }) => {
            try {
                store.dispatch('setIsLoading', true);
                const payload = {
                    formData: { ...data },
                    requestedBy: docOwner.value,
                    id: docId.value,
                    stage: formData.value.currentStageName,
                };
                const res = await httpClient.post(`/bff/starter/${name}`, payload);
                formData.value = res.data.body?.Item ?? {};
                saveStorage('formData', JSON.stringify(formData.value));
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'SAVED!',
                    message: 'The form has been saved.',
                });
                router.push('/');
                store.dispatch('setIsLoading', false);
            }
            catch (err) {
                console.log(err);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'There was an error submitting the form',
                });
                store.dispatch('setIsLoading', false);
            }
        };
        const handleUpdateFormData = ({ formName, data, }) => {
            formData.value[formName] = data;
            saveStorage('formData', JSON.stringify(formData.value));
        };
        const docId = computed(() => router.currentRoute.value.params.id);
        const docOwner = computed(() => router.currentRoute.value.params.docOwner);
        const fetchFormData = async () => {
            const response = await httpClient.post('/bff/get-document', {
                id: docId.value,
                requestedBy: docOwner.value,
            });
            formData.value = response.data.body?.Item ?? {};
            saveStorage('formData', JSON.stringify(formData.value));
        };
        const fetchConfigItems = async () => {
            const response = await httpClient.post('/config/all', {
                requestedBy: 'something',
            });
            configItems.value = response.data.body;
        };
        const findStage = (stageName, status) => {
            const foundStage = stages.find((stage) => stage.stageName === stageName);
            if (foundStage)
                return foundStage.displayName;
            const stage = status === 'DRAFT' ? 'Work in progress' : status;
            return stage;
        };
        const handleReassign = () => {
            const id = formData.value.docId;
            const docOwner = formData.value.requestedBy;
            router.push(`/re-assign/${id}/${docOwner}`);
        };
        onBeforeMount(async () => {
            await fetchFormData();
            await fetchConfigItems();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(formLayout, {
                "nav-item-config": navItemConfig,
                "current-nav-item": currentNavItem.value,
                "form-point": formPoint.value,
                "form-data": formData.value,
                "display-header": true,
                "form-name": "leaverForm",
                onSetCurrentNavItem: setCurrentNavItem
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_3, _toDisplayString(formData.value.shortId), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_6, _toDisplayString(formData.value.formThree.jobTitle), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_9, _toDisplayString(findStage(formData.value.currentStageName, formData.value.status)), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_12, _toDisplayString(formData.value.formOne?.hiringManagerEmail ?? formData.value.currentAssigneeEmail), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(),
                        _createElementVNode("dd", _hoisted_15, _toDisplayString(formData.value.docType), 1)
                    ]),
                    _createTextVNode(),
                    (profile.value?.ADMIN || profile.value?.H2R || profile.value?.RESOURCING)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                                class: "text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                                onClick: _withModifiers(handleReassign, ["prevent"])
                            }, "Re-assign")
                        ]))
                        : _createCommentVNode("", true)
                ]),
                navFooter: _withCtx(() => [
                    (formData.value?.currentStageName === 'starter.notifyCandidateSelected')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "w-full inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                            onClick: handleCloseAtr
                        }, "Close ATR"))
                        : _createCommentVNode("", true)
                ]),
                main: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentNavItem.value?.component), {
                        data: formData.value,
                        "form-data": formData.value[currentNavItem.value?.name],
                        "disable-form": disableForm.value,
                        "show-approval-steps": disableForm.value,
                        "config-items": configItems.value,
                        "config-data": configItems.value,
                        "onUpdate:formData": handleUpdateFormData,
                        onSubmitForm: handleSubmitForm,
                        onGenerateAdditionalOffers: handleGenerateOffers
                    }, null, 40, ["data", "form-data", "disable-form", "show-approval-steps", "config-items", "config-data"]))
                ]),
                _: 1
            }, 8, ["current-nav-item", "form-point", "form-data"]));
        };
    }
});
